const ContractTypes = {
    CME: 'CME',
    OTC: 'OTC',
    PHYSICAL: 'Physical',
};

export { ContractTypes };



// WEBPACK FOOTER //
// ./source/constants/contract.js